import { InfoTip } from './InfoTip'

export function PartialPeriods({ checked, onChange }: { checked: boolean; onChange: (value: boolean) => void }) {
  return <div className="article-period-control">
    <label><input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} /> Show partial periods</label>
    {/* MPD-64: the state stays visible (partial marker); why it matters goes in the ⓘ. */}
    <p>
      {checked ? 'Partial periods included' : 'Partial periods excluded'}
      <InfoTip label="About partial periods" size="small">
        A partial period (for example the current month) has fewer days, so its total is not comparable
        with a full period. Totals still cover the whole selected range.
      </InfoTip>
    </p>
  </div>
}
